import React, { useRef, useState } from "react"
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom"
import Home from "./pages/Home"
import About from "./pages/About"
import Contact from "./pages/Contact"
import Login from "./pages/Login"
import Signup from "./pages/Signup"
import ProFeatures from "./pages/ProFeatures"
import ForgotPassword from "./pages/ForgotPassword"
import ResetPassword from "./pages/ResetPassword"
import { lightTheme, darkTheme } from "./theme/theme"
import { Helmet, HelmetProvider } from "react-helmet-async"
import CustomNav from "./components/CustomNav"
import GetSingleImageDim from "./components/GetSingleImageDim"
import PageLayout from "./pages/PageLayout"
import { styled /* useTheme */ } from "@mui/material/styles"
import { ThemeProvider, CssBaseline, Box } from "@mui/material"
import { Circles } from "react-loader-spinner";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

const AppWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
});

const ContentWrapper = styled(Box)({
  flex: "1 0 auto",
});

const MetaTags = ({ isSearchable }) => {
  const { pathname } = useLocation();
  const origin = window.location.origin;

  return (
    <Helmet>
      {/* always: self-referencing canonical */}
      <link
        rel="canonical"
        href={`${origin}${pathname}`}
      />

      {/* only when not searchable */}
      {!isSearchable && (
        <meta name="robots" content="noindex" />
      )}
    </Helmet>
  );
};

const App = () => {
  const [showSearch, setShowSearch] = useState(false);
  const [imageDimensions, setImageDimensions] = useState(null);
  const [posters, setPosters] = useState([]);
  const initialLoadRef = useRef(true);

  const apiBase = process.env.REACT_APP_API_BASE_URL;
  const apiver = `${apiBase}/api/v3`;
  const singleImg = `${apiver}/image/tt1075747`;

  const isSearchable = process.env.REACT_APP_SEARCHABLE === "true";
  //const theme = useTheme()
  //console.log(theme)

  if (!imageDimensions) {
//    console.log("in not imageDimensions");
    return (
      <div>
        <GetSingleImageDim
          imgUrl={singleImg}
          onImageLoaded={(h, w) => {
//            console.log('onImageLoaded called with:', { h, w });
            setImageDimensions({ height: h, width: w })
          }}
        />
       <Circles color="#7D8C91" height={80} width={80} />
      </div>
    );
  }

  return (
    <HelmetProvider>
      <ThemeProvider theme={lightTheme}>
        <CssBaseline />
        {/* <ThemeInspector /> */}
        <Router>
          <MetaTags isSearchable={isSearchable} />

          <AppWrapper>
            <CustomNav showSearch={showSearch} setShowSearch={setShowSearch} />
            <ContentWrapper>
              <Routes>
                <Route
                  exact
                  path="/"
                  element={
                    <Home
                      showSearch={showSearch}
                      setShowSearch={setShowSearch}
                      imageDimensions={imageDimensions}
                      posters={posters}
                      setPosters={setPosters}
                      initialLoadRef={initialLoadRef}
                    />
                  }
                />
                <Route
                  exact
                  path="/about"
                  element={
                    <PageLayout>
                      <About />
                    </PageLayout>
                  }
                />
                <Route
                  exact
                  path="/contact"
                  element={
                    <PageLayout>
                      <Contact />
                    </PageLayout>
                  }
                />
                <Route
                  exact
                  path="/login"
                  element={
                    <PageLayout>
                      <Login />
                    </PageLayout>
                  }
                />
                <Route
                  exact
                  path="/forgot-password"
                  element={
                    <PageLayout>
                      <ForgotPassword />
                    </PageLayout>
                  }
                />
                <Route
                  exact
                  path="/reset-password"
                  element={
                    <PageLayout>
                      <ResetPassword />
                    </PageLayout>
                  }
                />
                <Route
                  exact
                  path="/signup"
                  element={
                    <PageLayout>
                      <Signup />
                    </PageLayout>
                  }
                />
                <Route
                  exact
                  path="/pro"
                  element={
                    <PageLayout>
                      <ProFeatures />
                    </PageLayout>
                  }
                />
          </Routes>
        </ContentWrapper>
      </AppWrapper>
      <ToastContainer />
    </Router>
  </ThemeProvider>
</HelmetProvider>
);
}

export default App
